import { router } from '@inertiajs/vue3'

import { cleanupSubscriptions } from '@/collections'
import { route } from '@/Composables/route'

/**
 * Logout function that cleans up subscriptions before logging out.
 * Call this instead of directly calling router.post(route('logout')).
 */
export function logout(): void {
  cleanupSubscriptions()
  router.post(route('logout'))
}
